import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Rightpart.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import { fetchUserAppAPI } from "../../utils/api";
import AddAddressModal from "../../components/AddAddressModal";

export default function WishlistRight() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);

  // Add Address states
  const [showAddForm, setShowAddForm] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [plotNo, setPlotNo] = useState("");
  const [locality, setLocality] = useState("");
  const [area, setArea] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedCityId, setSelectedCityId] = useState("");
  const [selectedLocalityId, setSelectedLocalityId] = useState("");
  const [selectedAreaId, setSelectedAreaId] = useState("");
  const [pincode, setPincode] = useState("");

  const [statesList, setStatesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [localitiesList, setLocalitiesList] = useState([]);
  const [areasList, setAreasList] = useState([]);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) {
      navigate("/login");
      return;
    }

    const parsedUser = JSON.parse(storedUser);
    setUser(parsedUser);
    fetchAddresses(parsedUser.user_id);
    fetchStates();
  }, [navigate]);

  const fetchStates = async () => {
    try {
      const res = await fetchUserAppAPI("get-state", { method: "GET" });
      if (res && res.status === 200 && Array.isArray(res.result)) {
        setStatesList(res.result);
      }
    } catch (err) {
      console.error("Error fetching states:", err);
    }
  };

  const fetchCities = async (stateId) => {
    setCitiesList([]);
    setLocalitiesList([]);
    setAreasList([]);
    setSelectedCityId("");
    setSelectedLocalityId("");
    setSelectedAreaId("");
    setLocality("");
    setArea("");
    setPincode("");

    if (!stateId) return;

    try {
      const res = await fetchUserAppAPI("get-city-by-state", {
        method: "POST",
        body: JSON.stringify({ state_id: stateId }),
      });
      if (res && res.status === 200 && Array.isArray(res.result)) {
        setCitiesList(res.result);
      }
    } catch (err) {
      console.error("Error fetching cities:", err);
    }
  };

  const fetchLocalities = async (cityId) => {
    setLocalitiesList([]);
    setAreasList([]);
    setSelectedLocalityId("");
    setSelectedAreaId("");
    setLocality("");
    setArea("");
    setPincode("");

    if (!cityId) return;

    try {
      const res = await fetchUserAppAPI("get-locality-by-city", {
        method: "POST",
        body: JSON.stringify({ city_id: cityId }),
      });
      if (res && res.status === 200 && Array.isArray(res.result)) {
        setLocalitiesList(res.result);
      }
    } catch (err) {
      console.error("Error fetching localities:", err);
    }
  };

  const fetchAreas = async (localityId) => {
    setAreasList([]);
    setSelectedAreaId("");
    setArea("");
    setPincode("");

    if (!localityId) return;

    try {
      const res = await fetchUserAppAPI("get-area-by-locality", {
        method: "POST",
        body: JSON.stringify({ locality_id: localityId }),
      });
      if (res && res.status === 200 && Array.isArray(res.result)) {
        setAreasList(res.result);
      }
    } catch (err) {
      console.error("Error fetching areas:", err);
    }
  };

  const handleStateChange = (e) => {
    const sId = e.target.value;
    setSelectedStateId(sId);
    fetchCities(sId);
  };

  const handleCityChange = (e) => {
    const cId = e.target.value;
    setSelectedCityId(cId);
    fetchLocalities(cId);
  };

  const handleLocalityChange = (e) => {
    const locVal = e.target.value;
    if (!locVal) {
      setSelectedLocalityId("");
      setLocality("");
      fetchAreas("");
      return;
    }
    const foundLoc = localitiesList.find(l => String(l.locality_id) === String(locVal) || l.locality_name === locVal);
    if (foundLoc) {
      setSelectedLocalityId(foundLoc.locality_id);
      setLocality(foundLoc.locality_name);
      fetchAreas(foundLoc.locality_id);
    } else {
      setSelectedLocalityId("");
      setLocality(locVal);
      fetchAreas("");
    }
  };

  const handleAreaChange = (e) => {
    const areaVal = e.target.value;
    if (!areaVal) {
      setSelectedAreaId("");
      setArea("");
      setPincode("");
      return;
    }
    const foundArea = areasList.find(a => String(a.area_id) === String(areaVal) || a.area_name === areaVal);
    if (foundArea) {
      setSelectedAreaId(foundArea.area_id);
      setArea(foundArea.area_name);
      if (foundArea.area_pincode) setPincode(foundArea.area_pincode);
    } else {
      setSelectedAreaId("");
      setArea(areaVal);
    }
  };

  const fetchAddresses = async (userId) => {
    setLoading(true);
    try {
      const response = await fetchUserAppAPI("list-address", {
        method: "POST",
        body: JSON.stringify({ user_id: userId }),
      });

      if (response && response.status === 200) {
        if (Array.isArray(response.result)) {
          setAddresses(response.result);
        } else {
          setAddresses([]);
        }
      }
    } catch (err) {
      console.error("Error fetching addresses:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddAddressSubmit = async (e) => {
    e.preventDefault();
    if (!user) return;

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const payload = {
        user_id: user.user_id,
        address_default: 1,
        address_title: title,
        address_name: name,
        address_phone: phone,
        address_plot_no: plotNo,
        address_locility: locality,
        address_area: area,
        address_city: selectedCityId,
        address_state: selectedStateId,
        address_pincode: pincode,
        address_latitude: "",
        address_longitude: "",
      };

      const response = await fetchUserAppAPI("add-address", {
        method: "POST",
        body: JSON.stringify(payload),
      });

      if (response && response.status === 200) {
        setSuccess("Address added successfully!");

        // Clear fields
        setTitle("");
        setName("");
        setPhone("");
        setPlotNo("");
        setLocality("");
        setArea("");
        setPincode("");

        setShowAddForm(false);
        // Refresh address list
        fetchAddresses(user.user_id);
      } else {
        setError(response.msg || "Failed to add address.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="outer-div-right">
      <div className="dashbord-right-section">
        <div className="outer-box-oc">
          <div className="row">
            <div className="col-lg-7 col-12">
              <div className="address-manager">
                <div className="box-top">
                  <div className="sr-number">
                    <h4>Saved Addresses</h4>
                  </div>
                </div>

                <div className="billing-text p-3">
                  {success && (
                    <div className="alert alert-success py-2">{success}</div>
                  )}

                  {loading && addresses.length === 0 ? (
                    <p className="text-muted small">Loading addresses...</p>
                  ) : addresses.length === 0 ? (
                    <p className="text-muted small">
                      No saved addresses found. Please add a new address.
                    </p>
                  ) : (
                    <div className="d-flex flex-column gap-3">
                      {addresses.map((addr) => (
                        <div
                          key={addr.address_id}
                          className="p-3 border rounded bg-light position-relative"
                        >
                          <span
                            className="badge bg-secondary mb-2"
                            style={{ textTransform: "capitalize" }}
                          >
                            {addr.address_title}
                          </span>
                          <h6 className="mb-1 text-dark fw-bold">
                            {addr.address_name}
                          </h6>
                          <p className="mb-2 text-muted small">
                            <LocalPhoneOutlinedIcon
                              style={{ fontSize: "14px", marginRight: "4px" }}
                            />{" "}
                            {addr.address_phone}
                          </p>
                          <div className="d-flex align-items-start gap-1">
                            <RoomOutlinedIcon
                              className="text-success mt-1"
                              style={{ fontSize: "18px" }}
                            />
                            <p className="mb-0 small text-dark">
                              {addr.address_plot_no}, {addr.address_locility},{" "}
                              {addr.address_area}, {addr.address_city_name || addr.address_city},{" "}
                              {addr.address_state_name || addr.address_state} - {addr.address_pincode}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-12">
              <div className="address-manager">
                <div className="box-top">
                  <div className="sr-number">
                    <h4>
                      {showAddForm ? "Fill Address Details" : "Add Address"}
                    </h4>
                  </div>
                </div>
                <div className="add-adres billing-text p-3">
                  {!showAddForm ? (
                    <div
                      className="text-center py-4"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowModal(true)}
                    >
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowModal(true);
                        }}
                      >
                        <AddOutlinedIcon style={{ fontSize: "40px" }} />
                      </a>
                      <p className="mt-2 text-muted small">
                        Click to add new address (Popup)
                      </p>
                    </div>
                  ) : (
                    <form onSubmit={handleAddAddressSubmit}>
                      {error && (
                        <div className="alert alert-danger py-1 small mb-2">
                          {error}
                        </div>
                      )}
                      <div className="mb-2">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Address Title (e.g. Home, Work)"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-2">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Contact Name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-2">
                        <input
                          type="tel"
                          className="form-control form-control-sm"
                          placeholder="Contact Phone"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-2">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Plot / Flat / House No."
                          value={plotNo}
                          onChange={(e) => setPlotNo(e.target.value)}
                          required
                        />
                      </div>

                      {/* State Dropdown */}
                      <div className="mb-2">
                        <select
                          className="form-select form-select-sm"
                          value={selectedStateId}
                          onChange={handleStateChange}
                          required
                        >
                          <option value="">Select State</option>
                          {statesList.map((st) => (
                            <option key={st.state_id} value={st.state_id}>
                              {st.state_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* City Dropdown */}
                      <div className="mb-2">
                        <select
                          className="form-select form-select-sm"
                          value={selectedCityId}
                          onChange={handleCityChange}
                          required
                        >
                          <option value="">Select City</option>
                          {citiesList.map((ct) => (
                            <option key={ct.city_id} value={ct.city_id}>
                              {ct.city_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Locality Dropdown / Input */}
                      <div className="mb-2">
                        {localitiesList.length > 0 ? (
                          <select
                            className="form-select form-select-sm"
                            value={selectedLocalityId || locality}
                            onChange={handleLocalityChange}
                            required
                          >
                            <option value="">Select Locality</option>
                            {localitiesList.map((loc) => (
                              <option key={loc.locality_id} value={loc.locality_id}>
                                {loc.locality_name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Locality Name"
                            value={locality}
                            onChange={(e) => setLocality(e.target.value)}
                            required
                          />
                        )}
                      </div>

                      {/* Area Dropdown / Input */}
                      <div className="mb-2">
                        {areasList.length > 0 ? (
                          <select
                            className="form-select form-select-sm"
                            value={selectedAreaId || area}
                            onChange={handleAreaChange}
                            required
                          >
                            <option value="">Select Area</option>
                            {areasList.map((ar) => (
                              <option key={ar.area_id} value={ar.area_id}>
                                {ar.area_name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Area Name"
                            value={area}
                            onChange={(e) => setArea(e.target.value)}
                            required
                          />
                        )}
                      </div>

                      {/* Pincode Field */}
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Pincode"
                          value={pincode}
                          onChange={(e) => setPincode(e.target.value)}
                          required
                        />
                      </div>

                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary flex-fill"
                          onClick={() => setShowAddForm(false)}
                          disabled={loading}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-sm btn-success flex-fill"
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <AddAddressModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={() => {
          if (user) fetchAddresses(user.user_id);
        }}
      />
    </div>
  );
}
